import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../features/shared/api/axios-instance';
import { PlatformDto } from '../../../features/shared/dtos/platform.dto';

export const getPlatforms = <TReturnType>(
  mapper: (dto: PlatformDto) => TReturnType
) =>
  createAsyncThunk<TReturnType[], void, Record<string, unknown>>(
    'get-platforms',
    async (): Promise<TReturnType[]> => {
      const { data }: AxiosResponse<PlatformDto[]> = await axiosInstance.get(
        '/platforms'
      );

      return data.map(mapper);
    }
  );
